import { useState } from 'react';

import { PlusIcon, XIcon } from 'assets/svgs';
import Text from '../Text';

interface Props {
  title: string;
  description: string;
}

const FoldingDescription = ({ title, description }: Props) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  function onClickButton() {
    setIsOpened((prev) => !prev);
  }
  return (
    <div className="flex w-full flex-col gap-4">
      <button type="button" className="flex h-6 w-full flex-row items-center justify-between" onClick={onClickButton}>
        <Text className="flex-1 text-left" size="body1" weight="regular" color="black">
          {title}
        </Text>
        <div className="flex h-6 w-6 items-center justify-center">
          {isOpened ? <XIcon className="h-3 w-3" /> : <PlusIcon className="h-3 w-3 " />}
        </div>
      </button>
      {isOpened && (
        <div className="w-full">
          <Text className="whitespace-pre-wrap" size="body2" weight="regular" color="black">
            {description}
          </Text>
        </div>
      )}
    </div>
  );
};

export default FoldingDescription;
